import { useQuery } from "@tanstack/react-query";
import { employeeService } from "../../api/employeeService";
import { getEmployeeId } from "../../utils/session";
import { MY_PROFILE_KEY } from "./profileUtils";

// GET /employee/me, shared by My Profile, the Dashboard and the Navbar.
export const useMyProfile = () =>
  useQuery({
    queryKey: [MY_PROFILE_KEY],
    queryFn: employeeService.getMe,
    enabled: !!getEmployeeId(),
    staleTime: 5 * 60 * 1000,
    retry: (count, error) => error?.response?.status !== 403 && count < 2,
  });
